import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faLink} from '@netx/core-icons';
import {canCreateShareLinkFromCategory} from '../enablers';
import {CategoryActionLabel} from '../locales';
import {type ICategory} from '../schema';
import {CATEGORY_EVENT} from './constants';

export const categoryActionCreatePDFShareLinkIcon = faLink;

/**
 * Create pdf share link from category assets
 * @param params
 * @returns Action
 */
export const categoryActionCreatePDFShareLink = (
	category?: ICategory,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-create-pdf-share-link',
	cb: () => dispatcher.trigger(CATEGORY_EVENT.CREATE_PDF_SHARE_LINK, category),
	enableTest: () => canCreateShareLinkFromCategory(category),
	icon: categoryActionCreatePDFShareLinkIcon,
	get label() {
		return CategoryActionLabel.CREATE_PDF_SHARE_LINK;
	},
	...params,
});

export default categoryActionCreatePDFShareLink;
